import styled from "@emotion/styled";
import { BLUE_LIGHT, OLD_BLUE } from "src/constants/colors";

export const Container = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  margin: 32px 0px;
`;

export const SummaryContainer = styled.div``;

export const ControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const NavButton = styled.button<{ disabled?: boolean }>`
  background-color: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  height: 30px;
  min-height: 30px;
  width: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${BLUE_LIGHT};
    color: ${OLD_BLUE};
  }

  &:active {
    background-color: rgba(239, 242, 246, 1);
  }

  &:disabled {
    background-color: transparent;
    cursur: not-allowed;
  }
`;
